<template>
  <div class="about" id="about">
    <!-- 头部导航组件 -->
    <header-cmp id="header" class="hidden-sm-and-down headerCmp"></header-cmp>
    <navCmp
      class="navCmp"
      :backgroundColor="''"
      :navColor="'#222'"
      :activeColor="'#DA5351'"
    ></navCmp>
    <!-- 新增资讯内容 -->
    <section class="myMain1">
      <div class="banner">
        <el-carousel class="banner-carousel" height="100%" arrow="always">
          <el-carousel-item v-for="(item, index) in bgImgs" :key="index">
            <img :src="item" class="banner-carousel-img" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- <div class="content">
        <div class="con-box pc">
          <h3>关于我们</h3>
          <span>ABOUT US</span>
        </div>
        <div class="con-box con-box-mobile">
          <el-row>
            <div class="line-box">
              <i class="line"></i>
              <i class="line"></i>
            </div>
            <h3>关于我们</h3>
            <div class="line-box">
              <i class="line"></i>
              <i class="line"></i>
            </div>
          </el-row>
          <el-row><span>ABOUT US</span></el-row>
        </div>
        <div class="con mobile about-box">
          <p class="desc" v-html="desc">
         
          </p>
          <img :src="companyImg" alt="" />
        </div>
      </div> -->
      <div class="content company">
        <div class="con-box pc">
          <h3>公司事纪</h3>
          <span>MILESTONES</span>
        </div>
        <div class="con-box con-box-mobile">
          <el-row>
            <div class="line-box">
              <i class="line"></i>
              <i class="line"></i>
            </div>
            <h3>公司事纪</h3>
            <div class="line-box">
              <i class="line"></i>
              <i class="line"></i>
            </div>
          </el-row>
          <el-row><span>MILESTONES</span></el-row>
        </div>
        <div class="con mobile">
          <div class="block" v-for="(item, index) in events" :key="index">
            <h3 style="line-height: 60px">
              {{ moment(item[0].eventdate).year() + "年" }}
            </h3>
            <el-timeline>
              <el-timeline-item
                v-for="(jtem, j) in item"
                :key="j"
                :timestamp="moment(jtem.eventdate).month() + 1 + '月'"
                placement="top"
              >
                <h4>{{ jtem.title }}</h4>
                <p style="color: #666666" v-html="jtem.content"></p>
                <div  v-if="jtem.img !== null && jtem.img !== ''">
                <img                 
                  :src="jtem.img"
                  alt=""
                /></div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
      <div class="content connect">
        <div class="con-box pc">
          <h3>联系我们</h3>
          <span>CONTACT US</span>
        </div>
        <div class="con-box con-box-mobile">
          <el-row>
            <div class="line-box">
              <i class="line"></i>
              <i class="line"></i>
            </div>
            <h3>联系我们</h3>
            <div class="line-box">
              <i class="line"></i>
              <i class="line"></i>
            </div>
          </el-row>
          <el-row><span>CONTACT US</span></el-row>
        </div>
        <div class="con mobile">
          <div class="left">
            <div class="message-box">
              <h3>中田认证服务(北京)有限公司</h3>
              <p>地址：{{ address }}</p>
              <p>业务邮箱：{{ mail }}</p>
              <p>廉政邮箱：zt@chinaath.com</p>
              <p>电话：{{ tel }}</p>
              <p>邮编：100020</p>
            </div>
            <div class="message-box wx mobile-wx">
              <ul>
                <li>
                  <p class="pc">官方公众号</p>
                  <img src="../assets/image/qrcode/offical.jpg" alt="" />
                  <p class="mobile-p">官方公众号</p>
                </li>
                <li>
                  <p class="pc">官方微信号</p>
                  <img src="../assets/image/qrcode/wechat.jpg" alt="" />
                  <p class="mobile-p">官方微信号</p>
                </li>
              </ul>
            </div>

            <!-- <img src="../assets/bg_img_1.jpg" alt=""> -->
          </div>
          <div class="right">
            <baidu-map
              style="height: 100%; width: 100%"
              :zoom="15"
              :ak="myMapKey"
              inertial-dragging
              :mapClick="false"
              :center="address"
              @ready="mapHandler"
            >
              <bm-marker
                :position="{ lng: 116.480207, lat: 39.842335 }"
                :dragging="false"
                animation="BMAP_ANIMATION_BOUNCE"
              >
                <bm-info-window :show="true"
                  >中田认证服务(北京)有限公司
                  <p>{{ address }}</p></bm-info-window
                >
              </bm-marker>

              <bm-view style="width: 100%; height: 100%; flex: 1"></bm-view>
            </baidu-map>
          </div>
        </div>
        <div class="msg-box msg-box-moblie">
          <p>
            * 有任何想跟我们沟通的内容请填写后提交，我们会在1-3个工作日内联系您
          </p>
          <el-form
            ref="addForm"
            :model="addForm"
            size="small"
            :rules="addRules"
          >
            <div class="input-box">
              <el-form-item style="width: 100%" prop="content">
                <el-input
                  type="textarea"
                  v-model="addForm.content"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </div>
            <div class="input-box input-box-list">
              <el-form-item style="width: 32%" prop="name">
                <el-input
                  size="small"
                  v-model="addForm.name"
                  placeholder="您的姓名"
                ></el-input>
              </el-form-item>

              <el-form-item style="width: 32%" prop="mail">
                <el-input
                  size="small"
                  v-model="addForm.mail"
                  placeholder="您的邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item style="width: 32%" prop="tel">
                <el-input
                  size="small"
                  v-model="addForm.tel"
                  placeholder="您的电话"
                ></el-input>
              </el-form-item>
            </div>
          </el-form>

          <div class="button-box">
            <button class="mobile-btn" @click="handleAdd">提交</button>
          </div>
        </div>
      </div>
    </section>
    <footer-cmp class="footCmp"></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "../components/common/header.vue";
import navCmp from "../components/common/navMenu.vue";
import footerCmp from "../components/common/footer.vue";
import { addFeedBack, eventList, info } from "../api/aboutUs";
import moment from "moment";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import { BmLocalSearch, BmNavigation } from "vue-baidu-map";
import BmView from "vue-baidu-map/components/map/MapView.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
export default {
  data() {
    return {
      myMapKey: "X4lQSPOcQT07sFPj45BCrVBNdaTzlbK7",

      center: { lng: 0, lat: 0 },
      zoom: 13,
      addForm: {
        id: null,
        content: null,
        createdate: new Date(),
        mail: null,
        name: null,
        status: 0,
        tel: null,
      },
      bgImgs: [],
      address: "北京市朝阳区博大路3号自主城1号楼",
      tel: "010-8716 1759",
      mail: "renzheng@chinaath.com",
      events: [],
      companyImg: "",
      addRules: {
        id: [{ required: false }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        content: [
          { required: true, message: "请输入反馈内容", trigger: "blur" },
        ],
        mail: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        createdate: [{ required: false }],
        status: [{ required: false }],
        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
      },
      desc: "为了保障竞赛公平和运动健康安全，在中国田径协会的指导下，中田体育扩展认证业务领域，规范认证业务发展，专门成立“中田认证服务中心”，秉承“鉴证品质 成就卓越”，以“权威标准 公正运作 客观评价 科学管理”为质量目标，做体育产业高质量发展的推动者。中田认证服务中心以中国田径协会现有认证业务为核心，重点梳理田径认证及相关业务标准化、体系化、系统化，实现认证服务数字化、一体化。致力成为集认证、培训、科研、政策研究、标准制定、国际合作、咨询服务于一体的综合性技术服务机构。",
    };
  },
  components: {
    headerCmp,
    navCmp,
    footerCmp,

    BaiduMap,
    BmView,
    BmInfoWindow,
    BmMarker,
    BmLocalSearch,
    BmNavigation,
    //ImgcardList
  },
  methods: {
    moment,
    handleAdd() {
      /**
       * @description 添加留言
       * @param
       */
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          addFeedBack(this.addForm).then((res) => {
            if (res.errCode == 0) {
              this.$message.success("反馈成功");
              this.$refs["addForm"].resetFields();
            } else {
              this.$message.error(res.errMessage);
            }
          });
        } else {
          return false;
        }
      });
    },
    getEvent() {
      /**
       * @description 获取事件列表
       */
      let entity = [];
      let param = { start: null, end: null, pageSize: null, pageIndex: null };
      eventList(param).then((res) => {
        if (res.errCode == 0) {
          entity = this.groupBy(res.data.list);
          this.events = JSON.parse(JSON.stringify(entity));
          this.events.forEach((e) => {

            e.forEach((x) => {
              if (x.img == "" || x.img == undefined) {
                x.img = null;
              }
            });
          });
          console.log("this.events", this.events);
        } else {
          this.$message.error(res.errMessage);
        }
      });
    },
    mapHandler({ map }) {
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 15;
      this.map = map;
    },
    groupBy(array) {
      var groups = {};
      array.forEach(function (o) {
        var group = moment(o.eventdate).format("yyyy");
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });

      var result = [];
      Object.keys(groups).forEach((g) => {
        result.push(groups[g]);
      });

      return result;
    },
    getBgImg() {
      info(["aboutBgImg", "address", "mail", "tel","companyImg" ,"companyInfo"]).then(
        (res) => {
          if (res.errCode == 0) {
            this.bgImgs = JSON.parse(res.data.aboutBgImg);
            this.address = res.data.address;
            this.mail = res.data.mail;
            this.desc = res.data.companyInfo;
            this.tel = res.data.tel;
            this.companyImg = res.data.companyImg;
          } else {
          }
        }
      );
    },
  },
  mounted() {
    this.getEvent();
    this.getBgImg();
  },
};
</script>

<style lang="scss" scoped>
// @import "../assets/style/media.scss";
::v-deep .el-timeline-item__timestamp.is-top {
  position: absolute;
  left: -60px;
  top: -3px;
  color: #333333;
}
::v-deep .el-timeline {
  padding-left: 100px;
}
#about {
  width: 100%;
  height: 100%;
  font-size: 14px;
  .myMain {
    max-width: 1200px !important;
    margin: 0 auto;
  }
  section .banner {
    width: 100%;
    height: 580px;
    background-color: #000000;
    .banner-carousel {
      width: 100%;
      height: 100%;
      &-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

  section {
    .content {
      height: auto;
      width: 100%;
      background-color: #fff;
      padding-top: 70px;
      box-sizing: border-box;

      .con-box,
      div.con,
      .msg-box {
        width: 1200px;
        margin: 0 auto;
        padding: 0 0 40px;
        box-sizing: border-box;
      }

      .con-box {
        text-align: center;
        // height: 60px;
        display: flex;
        flex-direction: column;

        h3 {
          font-size: 38px;
          color: #da5351;
        }

        span {
          font-size: 18px;
          color: #999;
          margin-top: 10px;
        }
      }

      .con-box-mobile {
        display: none;
      }

      div.con {
        font-size: 16px;
        color: #454545;
        line-height: 25px;

        .block {
          img {
            width: 199px;
            height: 119px;
            object-fit: cover;
          }
        }

        p.desc {
          font-size: 16px;
          color: #454545;
        }

        img {
          width: 100%;
          height: 360px;
          border-radius: 8px;
          object-fit: cover;
        }
      }

      .about-box {
        img {
          margin-top: 20px;
        }
      }
    }

    .company {
      background-color: #f5f5f5;
    }

    .connect .con {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .left {
        .message-box {
          width: 400px;
          line-height: 40px;

          h3 {
            font-size: 26px;
            color: #333;
          }

          p {
            font-size: 18px;
            color: #666666;
          }

          p.mobile-p {
            display: none;
          }

          img {
            width: 100px;
            height: 100px;
            object-fit: cover;
          }

          ul {
            display: flex;
            flex-direction: row;
            margin-top: 10px;

            // justify-content: space-between;
            li {
              p {
                font-size: 16px;
                color: #666;
                text-align: center;
                line-height: 30px;
              }

              margin-right: 20px;
            }
          }
        }
      }

      .right {
        width: calc(100% - 400px);

        img {
          width: 100%;
          height: 328px;
          object-fit: cover;
        }
      }
    }

    .connect {
      .msg-box {
        // width: 80%;
        margin: 0 auto;

        .input-box,
        .button-box {
          display: flex;
          margin-top: 0.05rem;
        }

        .input-box-list {
          justify-content: space-between;
          margin-bottom: 0.05rem;
        }

        .button-box {
          justify-content: center;
          margin-bottom: 0.1rem;

          button {
            border: none;
            font-size: 24px;
            color: #fff;
            width: 260px;
            height: 60px;
            background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
            border-radius: 30px;
          }
        }

        p {
          text-align: center;
          font-size: 18px;
          color: #666;
        }
      }
    }
  }

  .footCmp ::v-deep .myMain {
    width: 1200px;
    margin: 0 auto;
  }
}

@media screen and (max-width: 960px) {
  ::v-deep .el-timeline-item__timestamp.is-top {
    position: absolute;
    left: -0.3rem;
    top: -3px;
    color: #333333;
  }

  ::v-deep .el-timeline {
    padding-left: 0.5rem;
  }

  #about {
    .footCmp {
      display: none !important;
    }
    .myMain {
      width: 100%;
    }
    .hidden-sm-and-down {
      display: none !important;
    }

    section {
      .content .con-box,
      .content div.con,
      .connect .msg-box {
        width: 90%;
        padding: 0%;
      }

      .banner {
        height: 2.1rem;
      }

      .content {
        padding-top: 0.32rem;
        box-sizing: border-box;
        .con-box {
          margin-bottom: 0.18rem;
        }

        .pc {
          display: none;
        }
        .con {
          p {
            font-size: 0.12rem !important;
          }
        }

        .con-box-mobile {
          display: block;
          padding-bottom: 0rem !important;

          .el-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            div.line-box {
              display: flex;
              flex-direction: column;

              // align-content: center;
              i {
                width: 20px;
                align-self: center;
                height: 1px;
                margin-bottom: 2px;
                background: #cc3b3f;
              }
            }

            h3 {
              font-size: 0.2rem;
              color: #333;
              margin-left: 0.05rem;
              margin-right: 0.05rem;
            }

            span {
              font-size: 0.12rem;
              color: #666;
            }
          }
        }

        .mobile {
          .desc {
            padding: 0.01rem 0;
            box-sizing: border-box;
          }

          img {
            height: 1.03rem !important;
          }
        }
      }

      .company {
        background: #fff;

        .mobile {
          .block h3 {
            padding-left: 0 !important;
          }
        }
      }

      .connect {
        .mobile {
          display: flex;
          flex-direction: column;
          padding: 15px 0;

          .left {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .message-box {
              line-height: 30px;
              width: 70%;

              h3 {
                font-size: 0.16rem;
              }

              p {
                font-size: 0.12rem !important;
                color: #666;
              }

              p.pc {
                display: none;
              }

              p.mobile-p {
                display: block;
                font-size: 0.12rem !important;
              }
            }
            .mobile-wx {
              width: 20%;
            }

            .wx ul {
              display: flex;
              flex-direction: column;

              li {
                margin-right: 0;
                text-align: center;

                p {
                  font-size: 0.12rem;
                }

                img {
                  width: 67px;
                  height: 67px !important;
                  object-fit: cover;
                }
              }
            }
          }

          .right {
            width: 100%;
            height: 146px;
            border-radius: 0%;

            img {
              height: 146px !important;
              object-fit: cover;
            }
          }
        }
      }
      .msg-box-moblie {
        p {
          font-size: 0.12rem !important;
          margin-bottom: 0.16rem;
          margin-top: 0.16rem;
        }

        .button-box {
          button.mobile-btn {
            width: 96px !important;
            height: 30px !important;
            border-radius: 15px !important;
            border: 1px solid #cc3b3f !important;
            background: #fff !important;
            color: #cc3b3f;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.el-timeline-item__wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.el-timeline-item__timestamp.is-top {
  width: 50px;
}

.el-timeline-item__content {
  width: calc(100% - 55px);
}

.el-timeline-item__node {
  background: #da5351;
}

//   .el-timeline-item__timestamp{
//   margin-left: -0.14rem !important;
// }
</style>
